// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Load Supabase configuration from environment variables
// These are set differently per environment:
// - Local development: .env file
// - Vercel Development: VITE_SUPABASE_URL + VITE_SUPABASE_PUBLISHABLE_KEY (Development environment)
// - Vercel Preview/Staging: VITE_SUPABASE_URL + VITE_SUPABASE_PUBLISHABLE_KEY (Preview environment)
// - Vercel Production: VITE_SUPABASE_URL + VITE_SUPABASE_PUBLISHABLE_KEY (Production environment)
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Validate required environment variables
if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    'Missing required Supabase environment variables. ' +
    'Please ensure VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY are set in your environment. ' +
    'For local development, check your .env file. ' +
    'For deployed environments, verify these variables are configured in Vercel.'
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Disable automatic URL token detection to prevent double verification
    // Our verify-email.tsx and reset-password.tsx handle tokens manually
    detectSessionInUrl: false,
  }
});

// Global auth state listener to handle invalid refresh tokens gracefully
// This catches errors during automatic token refresh (common when switching environments)
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED' && !session) {
    // Token refresh failed - likely invalid refresh token
    console.warn('[supabase/client] Token refresh failed, session cleared');
  }
});

// Handle initial session restoration errors by clearing invalid tokens
// This runs once when the module loads
(async () => {
  try {
    const { error } = await supabase.auth.getSession();
    if (error?.message?.includes('Refresh Token') || error?.code === 'refresh_token_not_found') {
      console.warn('[supabase/client] Invalid refresh token on init, clearing session');
      await supabase.auth.signOut();
    }
  } catch (e) {
    console.error('[supabase/client] Error during session init:', e);
  }
})();